export enum SettingsNavLink {
  UserProfile = "/settings/user-profile",
  AgentProfile = "/settings/agent-profile",
  AgencyDetails = "/settings/agency",
  Password = "/settings/password",
  ManageAgents = "/settings/agents",
  ManageBackofficeUsers = "/settings/backoffice-users",
  ManageAgencies = "/settings/agencies",
}
